import { createRouter, createWebHistory } from 'vue-router'
import GrowthModel from '../views/GrowthModel.vue'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: GrowthModel
    }
  ]
})

export default router
